import { useMutation } from "urql";

import { UpdateRestructureDetailDocument } from "../../../graphql/generated.ts";

export function useUpdateRestructureDetail() {
  return useMutation(UpdateRestructureDetailDocument);
}
